import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from './auth'
import {createSlice} from "@reduxjs/toolkit";
import {useSelector} from "react-redux";
import {rootReducer} from "../store";

export const userMetricsApi = createApi({
  baseQuery: baseQuery(),
  reducerPath: 'userMetricsApi',
  endpoints: (builder) => ({
    submitUserMetrics: builder.mutation<unknown, UserMetricsInput>({
      query: (body) => ({
        url: 'users/metrics/',
        method: 'POST',
        body,
        meta: {
          suppressUnauthorizedRedirect: true,
          suppressAccessDenied: true,
        },
      }),
    }),
  }),
})

export const userMetricsSlice = createSlice({
  name: 'userMetrics',
  initialState: {
    submitted: null as UserMetricsInput | null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      userMetricsApi.endpoints.submitUserMetrics.matchFulfilled,
      (state, { meta }) => {
        state.submitted = meta.arg.originalArgs;
      }
    );
  },
})

export const { useSubmitUserMetricsMutation } = userMetricsApi

export const useSubmittedUserMetrics = () => {
  return useSelector(({ userMetrics }: ReturnType<typeof rootReducer>) => userMetrics.submitted)
}
